import React from 'react';

import Field, { Props as FieldProps } from '../Field';

export const EmailField = (props: FieldProps) => (
  <Field label="Email*" type="email" name="email" autoComplete="email" {...props} />
);
